import { useForm } from '../Form';
import { useEffect } from 'libs/react';
import { useOnce } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
/**
 * @component useValue
 * @since 1.0.0
 */
export function useValue(name, prop, defaults) {
    const form = useForm();
    const [init] = useState(defaults);
    /*
     * The value is initialized using its form stored value when no value
     * are explicitly specified.
     */
    useOnce(() => {
        if (prop == null) {
            prop = form.getValue(name);
        }
    });
    if (prop == null) {
        prop = init;
    }
    const [value, setValue] = useState(prop);
    /*
     * Updates the value when the prop
     * changes.
     */
    useWatch(() => {
        if (prop == null) {
            prop = init;
        }
        setValue(prop);
    }, [prop]);
    /*
     * Updates the form when the value
     * changes.
     */
    useEffect(() => {
        form.updateValue(name, value);
        return () => {
            form.removeValue(name);
        };
    }, [value]);
    /*
     * Assigns the initial prop when the form
     * resets.
     */
    useEffect(() => {
        /**
         * @function onReset
         * @since 1.0.0
         */
        function onReset() {
            setValue(prop);
        }
        form.appendResetListener(onReset);
        return () => {
            form.removeResetListener(onReset);
        };
    }, []);
    return [value, setValue];
}
